export default __webpack_public_path__ + "static/media/harold_experiences_fear.1110b2b6.png";